import { ref, watch, nextTick } from '@nuxtjs/composition-api';

const isCriteoLoaded = ref(false);
export const initializeCriteoOnly = (adTags, options, adConfig) => {
  if (!isCriteoLoaded.value) {
    adTags.script.push(
      {
        hid: 'criteo',
        src: 'https://static.criteo.net/js/ld/publishertag.js',
        async: true,
        callback: () => {
          // console.log('LOADED CRITEO');
          isCriteoLoaded.value = true;
        },
      },
      {
        hid: 'criteoInit',
        innerHTML: `
          window.Criteo = window.Criteo || {};
          window.Criteo.events = window.Criteo.events || [];
        `,
      }
    );
    if (process.client) {
      nextTick(() => {
        watch(isCriteoLoaded, () => {
          if (isCriteoLoaded.value) {
            // console.log('CALLED Criteo');
            const criteoAds = adConfig.value.criteoArticleUnits;
            window.Criteo.events.push(() => {
              window.Criteo.Passback.RequestBids(criteoAds, 1500);
            });
            window.Criteo.events.push(() => {
              criteoAds.placements.forEach((item) => {
                window.Criteo.Passback.RenderAd(item.slotid, (unit) => {
                  if (document.getElementById(unit).parentElement.parentElement.style.background) {
                    document.getElementById(unit).parentElement.parentElement.style.display = 'none';
                  }
                  document.getElementById(unit).parentElement.style.display = 'none';
                });
              });
            });
          }
        });
      });
    }
  }
};
